/* Vendôme — recordCounter error mute — patched 2026-05-06 */
(function () {
  'use strict';
  var MUTED_NEEDLES = ['recordcounter outside of context', 'invalid attempt to call recordcounter'];
  function isMuted(msg) {
    if (!msg) return false;
    var m = String(msg).toLowerCase();
    for (var i = 0; i < MUTED_NEEDLES.length; i++) {
      if (m.indexOf(MUTED_NEEDLES[i]) !== -1) return true;
    }
    return false;
  }
  window.addEventListener('error', function (e) {
    if (isMuted(e && e.message)) { e.stopImmediatePropagation(); e.preventDefault(); return false; }
  }, true);
  window.addEventListener('unhandledrejection', function (e) {
    var reason = e && e.reason;
    var msg = reason && reason.message ? reason.message : String(reason || '');
    if (isMuted(msg)) { e.stopImmediatePropagation(); e.preventDefault(); return false; }
  }, true);
  var prevOnError = window.onerror;
  window.onerror = function (msg, src, ln, col, err) {
    if (isMuted(msg) || (err && isMuted(err.message))) return true;
    if (typeof prevOnError === 'function') return prevOnError.apply(this, arguments);
    return false;
  };
})();
